import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DealAnalysisSheetFacade } from 'src/app/_shared/component/deal-analysis-sheet/deal-analysis-sheet.facade';
import { InsuranceAmountInput } from 'src/app/_shared/interface/deal-analysis.interface';
import { ToNumberPipe } from 'src/app/_shared/pipe/to-number.pipe';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import { DealAnalysisService } from 'src/app/_shared/service/deal-analysis.service';
import constant from 'src/constant.json';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';

@Component({
  selector: 'app-property-monthly-cost',
  templateUrl: './property-monthly-cost.component.html',
  styleUrls: ['./property-monthly-cost.component.scss'],
})
export class PropertyMonthlyCostComponent implements OnInit {
  onDestroyNotifier$ = new Subject();
  hoaFeeValue = 0;
  propertyTaxValue = 0;
  insuranceValue = 0;
  mortgagePaymentMonthly = 0;
  interestRate = 3.5;
  mortgageTypes = 30;
  downPaymentRate = 20;
  totalPaymentMonthly: number;
  potentialMonthlyRent: number;
  loggerAddress: any;
  mortgageListLength: number;
  pmxPropertyId;
  @ViewChild('hoaValuePopover') hoaValuePopover: NgbPopover;
  @ViewChild('homeInsurancePopover') homeInsurancePopover: NgbPopover;
  @ViewChild('potentialMonthlyRentPopover') potentialMonthlyRentPopover: NgbPopover;

  monthlyPaymentForm = this.formBuilder.group({
    customHomeInsuranceValue: new FormControl(null),
    customHoaValue: new FormControl(null),
    customPotentialMonthly: new FormControl(null),
  });
  isEquityAnalysis: boolean;

  constructor(
    private myHomeState: MyHomeState,
    private toNumberPipe: ToNumberPipe,
    private dealAnalysisService: DealAnalysisService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private myHomeService: MyHomeService,
    private activityLoggerService: ActivityLoggerService,
    private cdr: ChangeDetectorRef,
    public dealAnalysisSheetFacade: DealAnalysisSheetFacade
  ) { }

  ngOnInit(): void {
    const path = this.router.url.split('?')[0];
    if (path?.includes('equity-analysis')) {
      this.isEquityAnalysis = true;
    }

    // this.myHomeState.activePropertyDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
    //   this.totalPaymentMonthly = 0;
    //   if (res && res.listing) {
    //     const customHoaValue = this.myHomeState.activeHomeValue.customHoaValue || this.myHomeState?.customMonthlyDataOnLoad?.customHoaValue;
    //     const associationFee = res.listing.AssociationFee;
    //     this.hoaFeeValue = customHoaValue ? customHoaValue : associationFee ? this.getHoaFee(res) : 0;
    //     this.monthlyPaymentForm.patchValue({
    //       customHoaValue: this.hoaFeeValue,
    //     });
    //   }
    //   if (res && res.basic) {
    //     this.loggerAddress = {
    //       city: res.basic.City,
    //       state: res.basic.StateOrProvince,
    //       street: res.basic.StreetAddress,
    //       zip: res.basic.PostalCode,
    //     };

    //     this.pmxPropertyId = res.basic.PMXPropertyId;
    //     this.propertyTaxValue = res.basic.TaxAnnualAmount
    //       ? this.toNumberPipe.transform(res.basic.TaxAnnualAmount) / 12
    //       : 0;
    //     const customPotentialValue = this.myHomeState.activeHomeValue.customPotentialMonthlyRent || this.myHomeState?.customMonthlyDataOnLoad?.customPotentialMonthlyRent;
    //     this.potentialMonthlyRent = customPotentialValue
    //       ? customPotentialValue
    //       : res.basic.RentValue
    //         ? res.basic.RentValue
    //         : 0;
    //     this.monthlyPaymentForm.patchValue({
    //       customPotentialMonthly: this.potentialMonthlyRent,
    //     });
    //     let landValue =
    //       this.toNumberPipe.transform(res.basic.AssessedLandValue) ||
    //       this.toNumberPipe.transform(res.basic.AssessedValue) * 0.2 ||
    //       this.toNumberPipe.transform(res.basic.Lst_ListPrice) * 0.2 ||
    //       0;
    //     let homePrice = res.basic.Lst_ListPrice;
    //     let state = res.basic.StateOrProvince || 'DC';
    //     const customInsuranceValue = this.myHomeState.activeHomeValue.customInsuranceValue || this.myHomeState?.customMonthlyDataOnLoad?.customHomeInsuranceValue;
    //     this.insuranceValue = customInsuranceValue
    //       ? customInsuranceValue
    //       : this.getInsuranceAmount(homePrice, landValue, state, homePrice);

    //     this.monthlyPaymentForm.patchValue({
    //       customHomeInsuranceValue: this.insuranceValue,
    //     });
    //     let downPaymentRateCtrl = (this.downPaymentRate / 100) * homePrice || 0;
    //     const { monthlyMortgage } = this.dealAnalysisService.computeMonthlyMortgagePayment({
    //       uInterestRate: this.interestRate / 100,
    //       uLoanAmount: homePrice - downPaymentRateCtrl,
    //       uLoanTerm: this.mortgageTypes,
    //     });
    //     // let monthlyMortgagePayment = isFinite(monthlyMortgage) ? Math.round(Number(monthlyMortgage)) : 0;
    //     // this.mortgagePaymentMonthly = monthlyMortgagePayment;
    //     this.mortgageListLength = this.myHomeState?.mortgageListValue?.length;
    //     if (this.myHomeState?.mortgageListValue?.length) {
    //       const mortgageInfo = this.myHomeState.mortgageListValue[0];
    //       this.mortgagePaymentMonthly = this.calculateMortgagePaymentMonthly(mortgageInfo);
    //     } else this.mortgagePaymentMonthly = 0;
    //   }
    //   this.monthlyPaymentForm.valueChanges.subscribe(() => {
    //     this.calculateTotalPaymentMonthly();
    //   });
    //   // this.activatedRoute.queryParams.subscribe(params => {

    //   //   if (Number(params['rentValue'])) {
    //   //     this.potentialMonthlyRent = Number(params['rentValue'] || 0)
    //   //     this.monthlyPaymentForm.patchValue({
    //   //       customPotentialMonthly: this.potentialMonthlyRent,
    //   //     });
    //   //   }
    //   // });


    //   this.calculateTotalPaymentMonthly();
    // });

    combineLatest([
      this.myHomeState.activePropertyDetails$,
      this.myHomeState.mortgageList$
    ])
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(([res, mortgageList]: any) => {
        this.totalPaymentMonthly = 0;
        if (res && res.listing) {
          const customHoaValue = this.myHomeState.activeHomeValue.customHoaValue || this.myHomeState?.customMonthlyDataOnLoad?.customHoaValue;
          const associationFee = res.listing.AssociationFee;
          this.hoaFeeValue = customHoaValue ? customHoaValue : associationFee ? this.getHoaFee(res) : 0;
          this.monthlyPaymentForm.patchValue({
            customHoaValue: this.hoaFeeValue,
          });
        }
        if (res && res.basic) {
          this.loggerAddress = {
            city: res.basic.City,
            state: res.basic.StateOrProvince,
            street: res.basic.StreetAddress,
            zip: res.basic.PostalCode,
          };

          this.pmxPropertyId = res.basic.PMXPropertyId;
          this.propertyTaxValue = res.basic.TaxAnnualAmount
            ? this.toNumberPipe.transform(res.basic.TaxAnnualAmount) / 12
            : 0;
          const customPotentialValue = this.myHomeState.activeHomeValue.customPotentialMonthlyRent || this.myHomeState?.customMonthlyDataOnLoad?.customPotentialMonthlyRent;
          this.potentialMonthlyRent = customPotentialValue
            ? customPotentialValue
            : res.basic.RentValue
              ? res.basic.RentValue
              : 0;
          this.monthlyPaymentForm.patchValue({
            customPotentialMonthly: this.potentialMonthlyRent,
          });
          let landValue =
            this.toNumberPipe.transform(res.basic.AssessedLandValue) ||
            this.toNumberPipe.transform(res.basic.AssessedValue) * 0.2 ||
            this.toNumberPipe.transform(res.basic.Lst_ListPrice) * 0.2 ||
            0;
          let homePrice = res.basic.Lst_ListPrice;
          let state = res.basic.StateOrProvince || 'DC';
          const customInsuranceValue = this.myHomeState.activeHomeValue.customInsuranceValue || this.myHomeState?.customMonthlyDataOnLoad?.customHomeInsuranceValue;
          this.insuranceValue = customInsuranceValue
            ? customInsuranceValue
            : this.getInsuranceAmount(homePrice, landValue, state, homePrice);

          this.monthlyPaymentForm.patchValue({
            customHomeInsuranceValue: this.insuranceValue,
          });
          let downPaymentRateCtrl = (this.downPaymentRate / 100) * homePrice || 0;
          const { monthlyMortgage } = this.dealAnalysisService.computeMonthlyMortgagePayment({
            uInterestRate: this.interestRate / 100,
            uLoanAmount: homePrice - downPaymentRateCtrl,
            uLoanTerm: this.mortgageTypes,
          });
          // let monthlyMortgagePayment = isFinite(monthlyMortgage) ? Math.round(Number(monthlyMortgage)) : 0;
          // this.mortgagePaymentMonthly = monthlyMortgagePayment;
          if (mortgageList && mortgageList.length > 0) {
            this.mortgagePaymentMonthly =
              this.calculateMortgagePaymentMonthly(mortgageList[0]);
          } else {
            this.mortgagePaymentMonthly = 0;
          }
        }
        this.monthlyPaymentForm.valueChanges.subscribe(() => {
          this.calculateTotalPaymentMonthly();
        });
        // this.activatedRoute.queryParams.subscribe(params => {

        //   if (Number(params['rentValue'])) {
        //     this.potentialMonthlyRent = Number(params['rentValue'] || 0)
        //     this.monthlyPaymentForm.patchValue({
        //       customPotentialMonthly: this.potentialMonthlyRent,
        //     });
        //   }
        // });      

        this.calculateTotalPaymentMonthly();
      });

    // this.myHomeState.DealAnalysisHome$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
    //   if (res && Object.keys(res).length !== 0) {
    //     this.monthlyPaymentForm.get('customHomeInsuranceValue')?.reset();
    //     (this.insuranceValue = res.customInsuranceValue),
    //       (this.hoaFeeValue = res.customHoaValue),
    //       (this.potentialMonthlyRent = res.customPotentialMonthly);
    //     this.monthlyPaymentForm.setValue({
    //       customHomeInsuranceValue: res.customInsuranceValue,
    //       customHoaValue: res.customHoaValue ? res.customHoaValue : 0,
    //       customPotentialMonthly: res.customPotentialMonthly,
    //     });
    //     this.cdr.detectChanges();
    //   }
    // });


  }

  calculateMortgagePaymentMonthly(mortgageInfo) {
    const monthlyMortgageInput = {
      uLoanAmount: mortgageInfo.principal,
      uInterestRate: mortgageInfo.interest / 100,
      uLoanTerm: mortgageInfo.term / 12,
      uYear: 1,
    };
    const monthlyMortgagePayment = this.dealAnalysisSheetFacade.findMonthlyMortgagePayment(monthlyMortgageInput);
    return monthlyMortgagePayment.monthlyMortgage;
  }

  calculateTotalPaymentMonthly(): void {
    const { customHomeInsuranceValue, customHoaValue } = this.monthlyPaymentForm.value;

    this.totalPaymentMonthly =
      Number(this.mortgagePaymentMonthly || 0) +
      Number(this.propertyTaxValue || 0) +
      Number(customHomeInsuranceValue || 0) +
      Number(customHoaValue || 0);
  }

  openDealAnalysisSheet(propertyId) {
    this.logUserActivity(
      constant.LOGGER.myHome.category,
      constant.LOGGER.myHome.action.rentalReturn.key,
      propertyId,
      this.loggerAddress
    );

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        'deal-analysis-property-id': propertyId,
        'rentalAnalysis': true,
        // 'rentValue': this.monthlyPaymentForm.value.customPotentialMonthly
      },
      queryParamsHandling: 'merge',
    });

    let dealPageValue = {
      customPotentialMonthly: this.myHomeState.activeHomeValue.customPotentialMonthlyRent || this.potentialMonthlyRent,
      customHoaValue: this.myHomeState.activeHomeValue.customHoaValue || this.hoaFeeValue,
      customInsuranceValue: this.myHomeState.activeHomeValue.customInsuranceValue || this.insuranceValue,
      customPurchaseValue:
        this.myHomeState.activeHomeValue.customPurchaseValue || this.myHomeState.activeHomeValue.purchaseValue,
    };

    this.myHomeState.DealAnalysisHomeValue = dealPageValue;
  }

  getHoaFee(hoaFees): number {
    let af1 = 0;
    let af2 = 0;
    hoaFees = hoaFees?.listing;
    if (hoaFees?.AssociationFee != 0) {
      const AssociationFeevalues = [
        {
          fee: hoaFees?.AssociationFee,
          recurrence: hoaFees?.AssociationFeeFrequency,
        },
      ];
      af1 = this.dealAnalysisService.getHoaFee(AssociationFeevalues) / 12;
    }
    if (hoaFees?.AssociationFee2 != 0) {
      const AssociationFee2values = [
        {
          fee: hoaFees?.AssociationFee2,
          recurrence: hoaFees?.AssociationFee2Frequency,
        },
      ];
      af2 = this.dealAnalysisService.getHoaFee(AssociationFee2values) / 12;
    }
    return af1 + af2;
  }

  getInsuranceAmount(uFairMarketValue, uLandValue, uState, uPurchasePrice): number {
    // if (uLandValue < uFairMarketValue)
    if (uLandValue < uPurchasePrice) {
      const insuranceAmountInput: InsuranceAmountInput = {
        uInsuranceAmount: 0,
        uLandValue: uLandValue,
        uFairMarketValue: uFairMarketValue,
        uFairMarketValueYoYRatio: 0,
        uState: uState,
        uYear: 1,
        uPurchasePrice: uPurchasePrice,
      };
      const { insurance } = this.dealAnalysisService.computeInsuranceAmount(insuranceAmountInput);
      return insurance / 12;
    } else {
      let insurance = 0;
      return insurance;
    }
  }

  isNegativeOrder(value: number): boolean {
    return value < 0;
  }

  saveValue(event) {
    if (this.isEquityAnalysis) {
      let customeMonthlyCost = {}
      if (event == 'customHomeInsuranceValue') {
        customeMonthlyCost['customInsurance'] = this.monthlyPaymentForm.get('customHomeInsuranceValue')?.value;
        this.homeInsurancePopover.close();
      }
      if (event == 'customHoaValue') {
        customeMonthlyCost['customHoaFee'] = this.monthlyPaymentForm.get('customHoaValue')?.value;
        this.hoaValuePopover.close();
      }
      if (event == 'potentialMonthlyRent') {
        customeMonthlyCost['customMonthlyRent'] = this.monthlyPaymentForm.get('customPotentialMonthly')?.value;
        this.potentialMonthlyRentPopover.close();
      }

      if (event == 'customHomeInsuranceValue') {
        this.insuranceValue = this.monthlyPaymentForm.value.customHomeInsuranceValue.toFixed();

      } else if (event == 'customHoaValue') {
        this.hoaFeeValue = this.monthlyPaymentForm.value.customHoaValue.toFixed();

      } else if (event == 'potentialMonthlyRent') {
        this.potentialMonthlyRent = this.monthlyPaymentForm.value.customPotentialMonthly.toFixed();

      }
      const customMonthlyCost = {
        customHomeInsuranceValue: this.insuranceValue || null,
        customHoaValue: this.hoaFeeValue || null,
        customPotentialMonthlyRent: this.potentialMonthlyRent || null
      }
      this.myHomeState.customMonthlyData = customMonthlyCost;
      this.calculateTotalPaymentMonthly();


    } else {
      if (event == 'customHomeInsuranceValue') {
        this.saveEdited(event);
        this.homeInsurancePopover.close();
        this.logUserActivity(
          constant.LOGGER.myHome.category,
          constant.LOGGER.myHome.action.homeInsuranceUpdate.key,
          this.pmxPropertyId,
          this.loggerAddress
        );
      } else if (event == 'customHoaValue') {
        this.saveEdited(event);
        this.hoaValuePopover.close();
        this.logUserActivity(
          constant.LOGGER.myHome.category,
          constant.LOGGER.myHome.action.hoaUpdate.key,
          this.pmxPropertyId,
          this.loggerAddress
        );
      } else if (event == 'potentialMonthlyRent') {
        this.saveEdited(event);
        this.potentialMonthlyRentPopover.close();
        this.logUserActivity(
          constant.LOGGER.myHome.category,
          constant.LOGGER.myHome.action.hoaUpdate.key,
          this.pmxPropertyId,
          this.loggerAddress
        );
      }
      this.calculateTotalPaymentMonthly();
    }
  }

  saveEdited(event) {
    let myHomeValues = this.myHomeState.myHomeListValue.filter((myHome) => {
      return myHome.id == this.myHomeState.activeHomeValue.id;
    });
    myHomeValues = myHomeValues[0];
    if (event == 'customHomeInsuranceValue') {
      this.insuranceValue = this.monthlyPaymentForm.value.customHomeInsuranceValue.toFixed();
      myHomeValues.customInsuranceValue = this.monthlyPaymentForm.value.customHomeInsuranceValue.toFixed();
    } else if (event == 'customHoaValue') {
      this.hoaFeeValue = this.monthlyPaymentForm.value.customHoaValue.toFixed();
      myHomeValues.customHoaValue = this.monthlyPaymentForm.value.customHoaValue.toFixed();
    } else if (event == 'potentialMonthlyRent') {
      this.potentialMonthlyRent = this.monthlyPaymentForm.value.customPotentialMonthly.toFixed();
      myHomeValues.customPotentialMonthlyRent = this.monthlyPaymentForm.value.customPotentialMonthly.toFixed();
    }

    this.myHomeService
      .updateMyHomeValues([myHomeValues], false)
      .pipe()
      .subscribe((res: any) => { });
  }

  revertValue(value) {
    if (value == 'customHomeInsuranceValue') {
      this.monthlyPaymentForm.patchValue({
        customHomeInsuranceValue: this.insuranceValue,
      });
      this.monthlyPaymentForm.value.customHomeInsuranceValue;
    } else if (value == 'customHoaValue') {
      this.monthlyPaymentForm.patchValue({
        customHoaValue: this.hoaFeeValue,
      });
    } else if (value == 'potentialMonthlyRent') {
      this.monthlyPaymentForm.patchValue({
        customPotentialMonthly: this.potentialMonthlyRent,
      });
    }
  }

  logUserActivity(category, action, PMXPropertyId, address) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = {
      PMXPropertyId: PMXPropertyId,
      address: address,
    };
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    if (
      !/^[0-9]$/.test(event.key) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      event.key !== 'Home' &&
      event.key !== 'End'
    ) {
      event.preventDefault();
    }
  }
  ngOnDestroy() {
    this.myHomeState.DealAnalysisHomeValue = {};
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
